<template>

    <v-dialog max-width="800" v-model="model">

        <toolbar-page title="Members App links" icon="mdi-link" help="subpanel-settings-members-app-links">
            <template slot="buttons">
                <v-tooltip top color="primary">
                    <template v-slot:activator="{ on }">
                        <v-btn @click="model=false" v-on="on" icon>
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </template>
                    <span>Close</span>
                </v-tooltip>
            </template>
        </toolbar-page>

        <v-card class="pa-4">
            <title-card-list :disable-title="true"
                             title="Registration survey links"
                             help="subpanel-settings-registration-links">

                <member-app-link :sub-panel="subPanel"></member-app-link>

                <member-app-link v-for="locale in subPanel.locales" :key="locale.id"
                                 :locale="locale"
                                 :sub-panel="subPanel"
                ></member-app-link>

            </title-card-list>

        </v-card>


    </v-dialog>

</template>

<script>

import ToolbarPage from "../../../components/UI/ToolbarPage";
import TitleCardList from "../../../components/UI/TitleCardList";
import WidgetSettingsDialog from "./WidgetSettingsDialog";

import MemberAppLink from "./MemberAppLink";

export default {

    components: {
        MemberAppLink,
        WidgetSettingsDialog,
        ToolbarPage,
        TitleCardList
    },

    props: {
        value: {
            required: true,
            type: Boolean,
        },
        subPanel: {
            required: true,
            type: Object
        }
    },

    computed: {

        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
}
</script>
